/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AnnouncementList = {
    type: 'array',
    contains: {
        type: 'AnnouncementResponse',
    },
};